import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useNavigationHistory } from '@/hooks/use-navigation-history';

interface BreadcrumbsProps {
  currentPath: string;
  onNavigate: (path: string) => void;
  className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  currentPath,
  onNavigate,
  className,
}) => {
  const history = useNavigationHistory(currentPath);

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn('flex items-center space-x-1 text-sm text-muted-foreground', className)}
    >
      {history.map((entry, index) => {
        const isFirst = index === 0;
        const isLast = index === history.length - 1;

        return (
          <React.Fragment key={`${entry.path}-${index}`}>
            {!isFirst && <ChevronRight className="h-4 w-4 shrink-0" />}
            <button
              type="button"
              onClick={() => !isLast && onNavigate(entry.path)}
              disabled={isLast}
              className={cn(
                'flex items-center gap-1.5 transition-colors whitespace-nowrap',
                isLast
                  ? 'text-foreground font-medium cursor-default'
                  : 'hover:text-foreground cursor-pointer'
              )}
            >
              {entry.label}
            </button>
          </React.Fragment>
        );
      })}
    </nav>
  );
};
